export default function FormErrorMessage({message}: {message: string | null | undefined}) {
  if (!message) return null
  return (
    <p className="text-xs mt-2 font-medium text-red-700 dark:text-red-200 bg-red-50 dark:bg-red-950/40 p-2 rounded-sm">
      {message}
    </p>
  )
}
